module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_322dc350.184ccc6a.woff";